var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheck105 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 105,
  height: 105,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M92.807 15.105a.5.5 0 0 1 .088.702l-56 72a.5.5 0 0 1-.749.047l-24-24a.5.5 0 0 1 .708-.707l23.6 23.599 55.651-71.553a.5.5 0 0 1 .702-.088Z",
  clipRule: "evenodd"
})));
export { SvgCheck105 as ReactComponent };
export default __webpack_public_path__ + "b8a183421b61dd44289a07766976fe26.svg";